import request from '@/utils/request'

export function resetEmail(data) {
  return request({
    url: 'admin-auth/api/code/resetEmail',
    method: 'post',
    data
  })
}

export function updatePass(pass) {
  return request({
    url: 'admin-auth/api/users/updatePass/' + pass,
    method: 'get'
  })
}
